import { useEffect } from "react";
import { useCancelPaymentMutation } from "../redux/services/cancelPayment";
import { IAppConfigObject } from "../appConfig.interfaces";

export function useCancelOnReturnFromPayment(appConfig: IAppConfigObject) {
  const [cancelPayment] = useCancelPaymentMutation();

  useEffect(() => {
    const handlePageShow = () => {
      const tsString = sessionStorage.getItem("wentToPayment");
      const bookingId = sessionStorage.getItem("bookingId");
      if (!tsString || !bookingId) return;

      cancelPayment({ arg: { bookingId, config: appConfig } })
        .unwrap()
        .then(() => {
          console.log(`[cancel] Cancelled booking ${bookingId}`);
        })
        .catch((err: any) => {
          console.error(`[cancel] Failed to cancel booking ${bookingId}:`, err);
        })
        .finally(() => {
          sessionStorage.removeItem("wentToPayment");
          sessionStorage.removeItem("bookingId");
        });
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);
}
